import { render } from "./SetPrueba.vue?vue&type=template&id=e3e16a90"
import script from "./SetPrueba.vue?vue&type=script&lang=js"
export * from "./SetPrueba.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__